export default {
  arvoreItens: [],
  selectDespesas: [],
  selectReceitas: [],
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null,
    descricao: null,
    pai: null,
    tipo_movimento_nota: null,
    situacao: null
  }
}
